import { withInstall } from "../utils/index.mjs";
import _Radio from "./Radio.mjs";
const Radio = withInstall(_Radio);
var stdin_default = Radio;
import { radioProps } from "./Radio.mjs";
export {
  Radio,
  stdin_default as default,
  radioProps
};
